import { FC, useState } from 'react';
import { TextField, Button, FormControlLabel, Switch } from '@mui/material';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { useTranslation } from 'react-i18next';
import './SCUIAddRoleDialogContent.scss';
interface IProps {
    selectedRow?: any;
    onAddRole?: any;
    onCloseAddRole?: any;
}
export const SCUIAddRoleDialogContent: FC<IProps> = ({ selectedRow = null, onAddRole, onCloseAddRole }) => {
    const { t } = useTranslation();
    const [roleInput, setRoleInput] = useState({
        applicationId: 1,
        roleNameKey: selectedRow ? selectedRow?.text : '',
        isRequestable: false,
        description: '',
    });
    const submitHandler = (event: any) => {
        event.preventDefault();
        const currentOperator = JSON.parse(localStorage.getItem('checkOperator') || '{}');
        const roleData = {
            ...roleInput,
            IsRequestable: roleInput.isRequestable,
            createdBy: currentOperator?.userRef || undefined,
        };
        onAddRole(roleData);
    };

    return (
        <div>
            <form onSubmit={submitHandler}>
                <DialogContent>
                    <TextField
                        margin="dense"
                        id="roleNameKey"
                        label={t('authorizationManagement.roleName')}
                        type="text"
                        fullWidth
                        slotProps={{
                            inputLabel: {
                                shrink: true,
                            },
                        }}
                        variant="standard"
                        onChange={(e) => setRoleInput({ ...roleInput, roleNameKey: e.target.value })}
                    />
                    <TextField
                        margin="dense"
                        id="applicationId"
                        label={t('general.applicationId')}
                        type="number"
                        fullWidth
                        variant="standard"
                        slotProps={{
                            inputLabel: {
                                shrink: true,
                            },
                        }}
                        defaultValue={roleInput.applicationId}
                        onChange={(e) =>
                            setRoleInput({
                                ...roleInput,
                                applicationId: Number(e.target.value),
                            })
                        }
                    />
                    <TextField
                        margin="dense"
                        id="description"
                        label={t('general.description')}
                        type="text"
                        fullWidth
                        multiline
                        rows={3}
                        variant="standard"
                        slotProps={{
                            inputLabel: {
                                shrink: true,
                            },
                            htmlInput: {
                                maxLength: 1000,
                            },
                        }}
                        helperText={`${(roleInput.description || '').length}/1000`}
                        value={roleInput.description}
                        onChange={(e) => setRoleInput({ ...roleInput, description: e.target.value })}
                    />
                    <FormControlLabel
                        control={
                            <Switch
                                checked={roleInput.isRequestable}
                                onChange={(e) =>
                                    setRoleInput({
                                        ...roleInput,
                                        isRequestable: e.target.checked,
                                    })
                                }
                                color="primary"
                            />
                        }
                        label={t('roleApproval.isRequestable')}
                        sx={{ mt: 2 }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button type="submit">{t('general.add')}</Button>
                    <Button onClick={onCloseAddRole}>{t('general.cancel')}</Button>
                </DialogActions>
            </form>
        </div>
    );
};
